module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [(_vm.mostrarConfirmacionEliminar) ? _c('div', {
    key: "modal-editar",
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionEliminar = false
      },
      "do": function($event) {
        return _vm.eliminar()
      }
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarTitulo))]), _c('span', {
    attrs: {
      "slot": "information"
    },
    slot: "information"
  }, [_vm._v(_vm._s(_vm.confirmacionEliminarDescripcion))]), _c('i', {
    staticClass: "fa fa-video-camera",
    attrs: {
      "slot": "topIcon"
    },
    slot: "topIcon"
  }), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSendingEliminar) ? [_vm._v("Eliminando...")] : [_vm._v("Eliminar")]], 2)])], 1)], 1) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5 is-primary",
    on: {
      "click": function($event) {
        return _vm.redirigir(0)
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Nuevo")])]), _c('button', {
    staticClass: "button is-small",
    on: {
      "click": _vm.fetch
    }
  }, [_vm._m(2), _c('span', [_vm._v("Refrescar")])])]), _c('div', {
    staticClass: "body"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "is-loading"
  }, [_vm._m(3)]) : _c('div', {
    staticClass: "information"
  }, [(_vm.lista.length !== 0) ? [_c('div', {
    staticClass: "is-desktop"
  }, [_c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(4), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('tr', {
      key: index,
      staticClass: "row-table",
      class: {
        'is-close': !o.activo
      }
    }, [_c('td', [_c('div', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(_vm._f("truncateText")(o.titulo, 20)))])]), _c('td', [_vm._v(_vm._s(_vm._f("truncateText")(o.descripcion, 30)))]), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "display-flex flex-wrap space-around"
    }, [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_vm._m(5, true), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger m-2",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(6, true), _c('span', [_vm._v("Eliminar")])])])])])
  }), 0)], 1)]), _c('div', {
    staticClass: "is-mobile"
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: index,
      staticClass: "box"
    }, [_c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', {
      staticClass: "hint--top",
      attrs: {
        "aria-label": 'ID: ' + o.id
      }
    }, [_vm._v(_vm._s(o.titulo))])]), (o.descripcion) ? _c('div', {
      staticClass: "motivo"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(o.descripcion))])])]) : _vm._e(), _c('div', {
      staticClass: "botones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.redirigir(o.id)
        }
      }
    }, [_vm._m(7, true), _c('span', [_vm._v("Editar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarEliminar(o)
        }
      }
    }, [_vm._m(8, true), _c('span', [_vm._v("Eliminar")])])])])
  }), 0)] : _c('div', [_vm._m(9)])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Gestión de cursos virtuales")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Título")]), _c('th', [_vm._v("Descripción")]), _c('th')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay cursos registrados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-114a5fcc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_gestion_cursos_virtuales_lista.vue
// module id = 824
// module chunks = 0